import React, { useRef } from 'react';
import { colorScheme } from '../../default';
import SignaturePad from "react-signature-canvas";
import str2bin from "str2bin";
import swal from 'sweetalert';
import { Box, Card, Grid, Modal, Typography } from "@mui/material";
import MDButton from 'components/MDButton';
import Swal from 'sweetalert2';


function SignatureModel({ ...props }) {
  const sigCanvas = useRef({});
  document.body.style = `background: ${colorScheme.modalBodyBackground};`;

  const save = () => {
    if (sigCanvas.current.getTrimmedCanvas().width === 1) {
      // width===1 means sign canvas is empty
      Swal.fire({
        title: "Warning",
        text: "You haven't signed yet.",
        showCancelButton: false,
        confirmButtonText: "Ok",
        icon: "warning", customClass: { confirmButton: 'okbtnmodel' }
      });
      return
    } else {
      swal({
        title: `${props.titleMsg}`, customClass: "swal-modal swal-title", text: ``,
        closeOnClickOutside: false, closeOnEsc: false, buttons: {
          cancel: {
            text: "No", value: false, visible: true, className: "btn-block center-container-btn btn-warning no-button", closeModal: true,
          },
          confirm: {
            text: "Yes", value: true, visible: true, className: "btn-block center-container-btn btn-success yes-button", closeModal: true
          }
        }
      }).then((value) => {

        if (value) {
          const alp = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
          const base = alp.replace(/^data:image\/.+;base64,/, "");
          var finalBinary = str2bin.strToBin(base);
          var finalString = str2bin.binToStr(finalBinary);
          const imageSrc = ("src", "data:image/jpg;base64," + finalString);
          props.sign(imageSrc)
        } else {
          sigCanvas.current.clear();
        }
      })
    }
  }



  const clear = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
  };



  return (
    <Modal
      open={props.open}
      onClose={props.closeModalClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"

      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} // Center the modal
    >
      <Card style={{ padding: "10px", maxWidth: "90%", width: "auto" }}>
        <Box>
          <Grid sx={{ alignItems: "center", flexDirection: "column", display: "flex", justifyContent: "center" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >Please Sign Below</Typography>
            <SignaturePad
              ref={sigCanvas}
              canvasProps={{
                className: "sigCanvas",
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                width: '500px', height: '300px',
                padding: 'none',
                background: 'none',
                opacity: 1,
                border: 'none',
              }}
            />

          </Grid>

          <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
            <MDButton color="warning" className="modalButton" onClick={clear} style={{ marginRight: '8px', width: "87px" }}>
              Clear
            </MDButton>
            <MDButton color="error" className="modalButton" onClick={props.handleCancel} style={{ margin: '0 8px' }}>
              Cancel
            </MDButton>
            <MDButton color="success" className="modalButton" onClick={save} style={{ marginLeft: '8px', width: "87px" }}>
              Save
            </MDButton>
          </Grid>

        </Box>
      </Card>



    </Modal>
  );
}

export default SignatureModel;

